import React, { useEffect, useState } from 'react';
import {Box, Card, CardContent, TextField, InputAdornment, SvgIcon, makeStyles, Button, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from '@material-ui/core';
import Page from 'src/components/Page';
import PropTypes from 'prop-types';
import { Search as SearchIcon } from 'react-feather';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { WorkerService } from "../../../services/";
import * as ageCalculator from "age-calculator";
import moment from 'moment';
import { useNavigate } from "react-router-dom";


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  otherButton: {
    marginBottom: theme.spacing(3)
  },
}));



/******************* TOOLBAR *******************/
const Toolbar = ({ className, ...rest }) => {
    const classes = useStyles();
  
    return (
    <div>
        <Button className={classes.otherButton} color="primary" variant="outlined">Fill Worker Registration Form</Button>

        <Card>
            <CardContent>
                <Box maxWidth={500}>
                <TextField fullWidth InputProps={{startAdornment: (
                        <InputAdornment position="start">
                        <SvgIcon fontSize="small" color="action">
                            <SearchIcon />
                        </SvgIcon>
                        </InputAdornment>
                    )
                    }} placeholder="Search (worker names, vocational tags, ..)" variant="outlined"/>
                </Box>
            </CardContent>
        </Card>
    </div>
    );
  };
  
Toolbar.propTypes = {
  className: PropTypes.string
};
/******************* TOOLBAR *******************/



/******************** RESULTS ******************/
const Results = ({ className, preworkers, ...rest }) => {
    const classes = useStyles();
    const [limit, setLimit] = useState(5);
    const [page, setPage] = useState(0);
    const [workerId, setWorkerId] = useState(0);
    const handleLimitChange = (event) => { setLimit(event.target.value); };
    const navigate = useNavigate();
  
    const handlePageChange = (event, newPage) => {
      setPage(newPage);
    };

    const handleClickOpen = (workerId) => {
      setWorkerId(workerId);
      navigate("/app/worker_profile/" + workerId, { replace: true });
    };
  
    return (
    <Card>
        <PerfectScrollbar>
            <Box minWidth={1050}>
            <Table>
                <TableHead>
                <TableRow>
                    <TableCell style={{width: "5%"}}>#</TableCell>
                    <TableCell style={{width: "15%"}}>Worker</TableCell>
                    <TableCell style={{width: "5%"}}>Age</TableCell>
                    <TableCell style={{width: "10%"}}>Gender</TableCell>
                    <TableCell style={{width: "15%"}}>Email Address</TableCell>
                    <TableCell style={{width: "20%"}}>Vocational Tags</TableCell>
                    <TableCell style={{width: "10%"}}>Created At</TableCell>
                    <TableCell style={{width: "20%"}}>Actions</TableCell>
                </TableRow>
                </TableHead>

                <TableBody>
                {preworkers.slice(page * limit, page * limit + limit).map((worker) => (
                <TableRow hover key={worker.id}>
                    <TableCell >{worker.id}</TableCell>
                    <TableCell >{worker.firstName} {worker.lastName}</TableCell>
                    <TableCell >{ new ageCalculator.AgeFromDateString(worker.birthDate).age }</TableCell>
                    <TableCell >{worker.genderCode}</TableCell>
                    <TableCell >{worker.emailAddress}</TableCell>
                    <TableCell >{worker.englishTags}</TableCell>
                    <TableCell >{moment(worker.createDate).format('yyyy-MM-DD')}</TableCell>
                    <TableCell ><Button variant="outlined" color="secondary" onClick={() => { handleClickOpen(worker.id); }}>View / Edit</Button></TableCell>
                </TableRow>
                ))}
                </TableBody>
            </Table>
            </Box>
        </PerfectScrollbar>
        <TablePagination component="div" 
            count={preworkers.length}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[5,10, 50, 100]} />
    </Card>
    );
  };
  
Results.propTypes = {
    className: PropTypes.string,
    preworkers: PropTypes.array.isRequired
};
/******************** RESULTS ******************/

const Preworkers = () => {
  const classes = useStyles();
  const [preworkers, updatePreworkers] = useState([]);

  const getPreworkers = async () => {
    await WorkerService.GET_PREWORKERS()
    .then(({data}) =>{  
      updatePreworkers(data.data);         
    })
    .catch((error) => {
      console.log("Preworkers getting failed.");
    });
  }

  useEffect(function effectFunction(){
    getPreworkers();
  }, []);    

  return (
    <Page className={classes.root} title="Preworkers (Form Fillers)">
      <Toolbar />
      <Results preworkers={preworkers} />
    </Page>
  );
};

export default Preworkers;
